var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreelanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 24,
    fill: "#f5f2f4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 110,
    fontFamily: "monospace, Courier, sans-serif",
    fontSize: 64,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#6c63ff"
  }, "&lt;/&gt;")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelanceLogo);
export default __webpack_public_path__ + "static/media/freelance-logo.310b651a1f9def17298002dfcbd55615.svg";
export { ForwardRef as ReactComponent };